module.exports = __webpack_public_path__ + "img/info2.6dc1bdd0.png";